import Vue from 'vue';
import Axios from 'utils/axios';
import config from 'utils/config';
import 'components/index';
import './stylesheets/element-ui/_variables.scss';
import './stylesheets/animate.css';

import { sync } from 'vuex-router-sync';

Vue.config.productionTip = false;

var events = {
    on(event, cb, opts) {
        if (!this.namespaces)
            // save the namespaces on the DOM element itself
            this.namespaces = {};

        this.namespaces[event] = cb;
        var options = opts || false;

        this.addEventListener(event.split('.')[0], cb, options);
        return this;
    },
    off(event) {
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
    }
};

document.on = Element.prototype.on = events.on;
document.off = Element.prototype.off = events.off;

function getUploadToken() {
    Axios.post('/upload-token').then(function(response) {
        config.UPLOAD_TOKEN = response.data.token;
        setTimeout(() => {
            getUploadToken();
        }, 59 * 60 * 1000);
    });
}

export default (App, store, router, userem) => {
    // if(true){
    //   var pxUnit = 100;
    //   var bl = 1;
    //   document.querySelector('html').style.fontSize = bl * pxUnit + 'px';
    //   document.querySelector('body').style.fontSize = bl * pxUnit + 'px';
    // }
    sync(store, router);
    // getUploadToken()

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
};
